import { FiChevronLeft } from 'react-icons/fi'
import { clockTime, IMyTransactionView } from '../helpers'
import { KindAmount, KindTile } from '../parts'

interface IItemProps {
    item: IDashboardTransactionResult
    view: IMyTransactionView
    /** the page owns the one details sheet; a row only asks for it */
    onOpen: () => void
}

/**
 * One payment, read right to left the way it is said aloud: which box, what
 * for, who else was in it — then how much and when. The day is the heading
 * above, so only the time is repeated here.
 */
export default function Item({ item, view, onOpen }: IItemProps) {
    const time = clockTime(item)
    return (
        <button
            type="button"
            onClick={onOpen}
            className="flex w-full items-start gap-2.5 px-3 py-3 text-right transition-colors active:bg-sunken focus-visible:bg-sunken focus-visible:outline-none"
        >
            <span className="mt-0.5">
                <KindTile kind={view.kind} />
            </span>

            <span className="min-w-0 flex-1">
                <span className="block break-words text-[15px] font-bold leading-6 text-black">
                    {view.title}
                </span>
                <span className="mt-0.5 block text-[13px] leading-5 text-text-body">
                    {view.subtitle}
                </span>
                {view.party && (
                    <span className="mt-0.5 block truncate text-xs leading-5 text-text-secondary">
                        {view.party}
                    </span>
                )}
            </span>

            <span className="flex shrink-0 flex-col items-end">
                <KindAmount amount={item.amount} kind={view.kind} />
                <span className="mt-0.5 flex items-center gap-0.5 text-xs leading-5 text-text-secondary">
                    {time}
                    <FiChevronLeft
                        aria-hidden
                        className="-ml-1 h-3.5 w-3.5 text-text-muted"
                    />
                </span>
            </span>
        </button>
    )
}
